// extracted by mini-css-extract-plugin
export default {"header":"Header_header__g2BdF","siteName":"Header_siteName__7oC5i","nav":"Header_nav__ZeDKq","link":"Header_link__f7A2d"};